import './new-vehicle-transaction.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormVehicleTransaction from "../form-vehicle-transaction/form-vehicle-transaction";
import { useNewVehicleTransaction } from './new-vehicle-transaction.hook';

export function NewVehicleTransaction() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewVehicleTransaction();

  return (
    <div id="NewVehicleTransaction" className="vehicle-transaction">
      <HeaderContent
        title={<h1>New Vehicle Transaction</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormVehicleTransaction />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewVehicleTransaction;